
    (function(w) {
        w['_ekomiServerUrl'] = 'https://smartforms.ekomi.com';
        w['_ekomiShopId'] = '152573';
        w['_ekomiFormId'] = '454706';
        w['_ekomiTransactionId'] = 'transaction_id';
        w['_ekomiProductIds'] = 'product_ids';
        w['_ekomiWidgetWidth'] = '1020px';
        w['_ekomiWidgetHeight'] = '1290px';
        w['_ekomiEmbedWidget'] = '0';
        w['_ekomiDisableAutoClose'] = '0';
        w['_ekomiEmail'] = '';
        var s = document.createElement('script');
        s.src = w['_ekomiServerUrl']+'/script/widget.js?v='+ new Date().getTime();
        s.async = true;
        var e = document.getElementsByTagName('script')[0];
        e.parentNode.insertBefore(s, e);
    })(window);

